import { color } from './color';

export const border = {
	default: `1px solid ${color.border.default}`,
	highlight: `2px solid ${color.highlight}`,
};
